import { ApiPageEvent, PAGE, PageEvent } from '@unive/analytics';

export function mapPageEvent(event: PageEvent): ApiPageEvent {
  return {
    pagina_platform: 'web',
    pagina_omgeving: 'RU Dichtbij',
    pagina_naam: `RU Dichtbij:Home:${event.page}`,
    pagina_type: event.type ?? PAGE.ProductWizard,
    ...(!!event.form && { formulier_naam: event.form }),
    ...(!!event.form && { formulier_type: 'lead' }),
    ...(!!event.formStep && { formulier_stap: event.formStep }),
    ...(!!event.formStepName && { formulier_stap_naam: event.formStepName }),
  };
}
